import { Box } from '@mui/material'
import { formatConversationDayHeading } from '@/utils/conversationDayLabel'

/**
 * @param {{ createdAt?: number, calendarNow: number }} props
 */
export default function ChatThreadExchangeDayHeading({ createdAt, calendarNow }) {
  return (
    <Box
      component={typeof createdAt === 'number' ? 'time' : 'div'}
      {...(typeof createdAt === 'number'
        ? { dateTime: new Date(createdAt).toISOString() }
        : {})}
      sx={{
        display: 'block',
        flexShrink: 0,
        textAlign: 'center',
        width: '100%',
        typography: 'caption',
        fontWeight: 500,
        color: 'text.secondary',
        userSelect: 'none',
      }}
    >
      {formatConversationDayHeading(createdAt, { now: calendarNow })}
    </Box>
  )
}
